export default __webpack_public_path__ + "static/media/EM1010.34I-26643_-25098_0.abbb2a2b.jpg";